import React from 'react';
import { useSearchParams } from 'react-router-dom-v5-compat';

import { CHAMPVA_PROVIDERS } from '~/platform/shared/claims-appeals';
import recordEvent from 'platform/monitoring/record-event';
import TabItem from './TabItem';

export default function TabNav() {
  const [searchParams] = useSearchParams();
  const typeParam = searchParams.get('type');
  const isChampva = CHAMPVA_PROVIDERS.has(typeParam);
  const query = typeParam ? `?type=${typeParam}` : '';
  const navLabel = isChampva ? 'Application' : 'Claim';
  const handleTabSelect = (text, url) => {
    if (isChampva) {
      recordEvent({
        event: 'nav-in-page',
        'nav-link-text': text,
        'nav-link-url': url,
      });
    }
  };

  return (
    <nav aria-label={navLabel}>
      <ul className="tabs">
        <TabItem
          shortcut={1}
          tabpath={`../status${query}`}
          title="Status"
          onTabSelect={handleTabSelect}
        />
        <TabItem
          shortcut={2}
          tabpath={`../files${query}`}
          title="Files"
          onTabSelect={handleTabSelect}
        />
        <TabItem
          shortcut={3}
          tabpath={`../overview${query}`}
          title="Overview"
          onTabSelect={handleTabSelect}
        />
      </ul>
    </nav>
  );
}

TabNav.propTypes = {};
